module.exports = __webpack_public_path__ + "img/intro.cc17ff8b.png";